export const DownArrow = ({
  strokeColor = "var(--color-red)",
  ...props
}: any) => (
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
    <path
      d="M6.5 2.5L6.5 9.5M6.5 9.5L10 6M6.5 9.5L3 6"
      stroke={strokeColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UpArrow = ({strokeColor = "var(--color-green)",
...props
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <path
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6 9.5v-7m0 0L2.5 6M6 2.5 9.5 6"
    />
  </svg>
)

export const SideArrow = ({strokeColor = "var(--color-yellow)",
...props
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9}
    height={10}
    fill="none"
    {...props}
  >
    <path
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1 5h7m0 0L4.5 1.5M8 5 4.5 8.5"
    />
  </svg>
)
